import { Analytics, AnalyticsGlobalContext } from 'big-brother';
import type { Centrifuge } from 'centrifuge';

import { buildAnalyticsEvents } from '../utils/analytics';
import { ANALYTICS_SCHEMA_URLS } from '../constants/analytics';

let analytics: Analytics;

export const initAnalytics = (
  centrifugeInstance: Centrifuge,
  globalContext: AnalyticsGlobalContext,
  crossdomainId?: string
) => {
  analytics = new Analytics({
    appId: 'casino',
    centrifugo: centrifugeInstance,
    globalContext,
    ...(crossdomainId ? { crossdomainId } : {}),
  });
  return analytics;
};

export const getAnalytics = () => analytics;

export const sendAnalyticsData = (analyticsData: any) => {
  const analytics = getAnalytics();
  if (analytics && analyticsData) {
    try {
      const { event, contexts } = buildAnalyticsEvents(analyticsData);
      analytics.push(event, contexts);
    } catch (err) {
      console.error('Error during analytics.push. Details: ', err);
    }
  }
};

export const sendErrorAnalyticsData = (analyticsData) => {
  const analytics = getAnalytics();
  if (analytics && analyticsData) {
    try {
      analytics.push({
        schema: ANALYTICS_SCHEMA_URLS.LOG_CLIENT_ERROR,
        data: {
          ...analyticsData,
        },
      });
    } catch (err) {
      console.error('Error during analytics.push. Details: ', err);
    }
  }
};
